<template>
  <ul class="filterItemCategoriesContainer py-1">
    <li v-for="(category, index) in categories" :key="category.id">
      <c-filter-item-category
        v-bind="category"
        :isFirstCategory="index === 0"
        :show-tags="showTags"
        @category-selected="onCategorySelected"
        @reset-category="$emit('reset-category')"
        @reset-tag="$emit('reset-tag')"
        @tag-selected="onTagSelected"
      ></c-filter-item-category>
      <div
        v-if="$slots.default"
        class="nav-vertical nav-vertical--nested filterItemCategoryContainer"
        style="display: block"
      >
        <div
          aria-label="Health condition filter message"
          class="nav-vertical__item flex-wrap cursor-pointer py-0"
        >
          <slot></slot>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import FilterItemCategory from '@/components/pages/filter/categories/FilterItemCategory'

export default {
  components: { 'c-filter-item-category': FilterItemCategory },
  props: { categories: { required: true, type: Array }, showTags: Boolean },
  methods: {
    getCategoryById(id) {
      return this.categories.find(c => c.id === id)
    },
    onCategorySelected(e) {
      this.$emit('category-selected', this.getCategoryById(e))
    },
    onTagSelected(e) {
      this.$emit('tag-selected', e)
    },
  },
}
</script>
